export function getSection(state, type) {
  return state.website.sections.filter(section => section.type === type);
}

export function getNumberOfMonthsInDatePicker(state) {
  return state.website.ui.winWidth < 768 ? 1 : 2;
}

export function getEmail(state) {
  const { companyInfo } = state.website;
  return companyInfo ? companyInfo.email : "";
}


// WEBPACK FOOTER //
// ./src/website/website.selectors.js